import React from 'react';

import Layout from '../components/Layout';

import logo from '../assets/images/logo.svg';
import pic1 from '../assets/images/pic01.svg';
import pic2 from '../assets/images/allconnect-logo.png';
import pic3 from '../assets/images/autotext-logo.svg';
import pic4 from '../assets/images/Note-taking apps.svg';
import pic5 from '../assets/images/Code Version Control.svg';
import hiphone from '../assets/images/Hi-Phone.png';
import hivpn from '../assets/images/HiVPN.png';

import config from '../../config';
const IndexPage = () => (
  <Layout>
    <section id="banner">
      <div className="inner">
        <div className="logo">
          <img src={logo} alt="heidi logo" width="250px" />
          {/* <span className="icon fa-cloud"></span> */}
          <h2>{config.heading}</h2>
        </div>
        <p>{config.subHeading}</p>
      </div>
    </section>

    <section id="wrapper">
      <section id="one" className="wrapper spotlight style1">
        <div className="inner">
          <a href="/#" className="image">
            <img src={pic1} alt="cloud service" />
          </a>
          <div className="content">
            <h2 className="major">Cloud Expert</h2>
            <p>
              We offer consulting services and software development for small to
              medium-sized businesses. Our expert team excels in creating
              tailored software and cloud-based solutions. If you have a
              groundbreaking concept and require a technology partner to bring
              it to life, we're here to assist.
            </p>
            <a href="/#services" className="special">
              Learn more
            </a>
          </div>
        </div>
      </section>

      <section id="two" className="wrapper alt spotlight style2">
        <div className="inner">
          <a href="/#" className="image">
            <img src={pic2} alt="allconnect vpn logo" />
          </a>
          <div className="content">
            <h2 className="major">AllConnect VPN</h2>
            <p>
              AllConnect, our Cloud VPN offering, is a cloud-native VPN platform
              engineered specifically for the Cloud. It delivers
              enterprise-grade SSL VPN accessibility to everyone.
            </p>
            <a href="https://getallconnect.com" className="special">
              Visit AllConnect Site
            </a>
          </div>
        </div>
      </section>

      <section id="three" className="wrapper spotlight style3">
        <div className="inner">
          <a href="/hi-phone" className="image">
            <img src={hiphone} alt="Hi-Phone logo" />
          </a>
          <div className="content">
            <h2 className="major">Hi-Phone SIMless Softphone</h2>
            <p>
              Hi-Phone is a highly capable softphone powered by the Cloud,
              supporting Voice, SMS, MMS, and more. It offers features such as
              mobile number selection, scheduled group messages even when
              offline, and AutoReply/AutoForward capabilities.
            </p>
            <a href="/hi-phone/" className="special">
              Learn More
            </a>
          </div>
        </div>
      </section>

      <section id="two" className="wrapper alt spotlight style2">
        <div className="inner">
          <a href="/hi-vpn" className="image">
            <img src={hivpn} alt="Hi-VPN logo" />
          </a>
          <div className="content">
            <h2 className="major">Hi-VPN: Doulbe VPN</h2>
            <p>
              Hi-VPN, a VPN app supported by AllConnect VPN, is available for
              both iOS and Android platforms. Uniquely offering both IKEv2 and
              AnyConnect SSL VPN protocols, Hi-VPN delivers enterprise-grade
              protection for your devices.
            </p>
            <a href="hi-vpn" className="special">
              Learn More
            </a>
          </div>
        </div>
      </section>

      <section id="services" className="wrapper alt style1">
        <div className="inner">
          <h2 className="major">Our Services</h2>
          <p>
            Our extensive expertise in Cloud-based product development ensures
            that we deliver fully functional software, rather than just
            documentation, to meet your needs.
          </p>
          <section className="features">
            <article>
              <a href="/#" className="image">
                <img src={pic4} alt="mobile & web development" />
              </a>
              <h3 className="major">Mobile & Web App</h3>
              <p>
                By utilizing cutting-edge technology, we create innovative,
                potent, and elegantly simple applications that streamline
                communication for individuals and small businesses.
              </p>
              {/* <a href="/#" className="special">
                Learn more
              </a> */}
            </article>
            <article>
              <a href="/#" className="image">
                <img src={pic5} alt="system integration" />
              </a>
              <h3 className="major">System Integration</h3>
              <p>
                We specialize in integrating Stripe billing workflows,
                implementing Apple/Google Play subscription business models, and
                incorporating Voice or Text APIs through Twilio.
              </p>
              {/* <a href="/#" className="special">
                Learn more
              </a> */}
            </article>
          </section>
          {/* <ul className="actions">
            <li>
              <a href="/#" className="button">
                Browse All
              </a>
            </li>
          </ul> */}
        </div>
      </section>
    </section>
  </Layout>
);

export default IndexPage;
